import { useAuth } from "@/contexts/AuthContext";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export default function StudentProfile() {
  const { user } = useAuth();
  return (
    <div data-testid="student-profile" className="space-y-6 max-w-2xl">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-primary">Profile</div>
        <h1 className="font-display font-bold text-3xl tracking-tight mt-1">You</h1>
      </div>
      <Card className="en-card p-6">
        <div className="flex items-center gap-4">
          <Avatar className="h-16 w-16"><AvatarImage src={user?.avatar} /><AvatarFallback>{user?.name?.[0]}</AvatarFallback></Avatar>
          <div>
            <div className="font-display font-bold text-xl">{user?.name}</div>
            <div className="text-sm text-muted-foreground">{user?.email}</div>
            <Badge variant="secondary" className="rounded-full mt-2">{user?.exam_target || "JEE"}</Badge>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3 mt-6">
          <Field label="Coins" value={user?.reward_coins || 0} />
          <Field label="Streak" value={`${user?.streak_days || 0} days`} />
          <Field label="Referral code" value={user?.referral_code} />
          <Field label="Joined" value={(user?.created_at || "").slice(0, 10)} />
        </div>
      </Card>
    </div>
  );
}
function Field({ label, value }) {
  return (
    <div className="p-3 rounded-xl border border-border">
      <div className="text-xs text-muted-foreground uppercase tracking-widest">{label}</div>
      <div className="font-medium mt-1">{value}</div>
    </div>
  );
}
